<template>
  <v-select
    ref="select"
    maxHeight="100px"
    v-model="innerValue"
    :options="options"
    :placeholder="placeholder"
    :class="{ selectd: innerValue }"
    :searchable="false"
    @option:selected="handleSelect"
  >
    <template v-slot:no-options="{}">
      {{ noOptionsText }}
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
  mounted() {
    this.$nextTick(() => {
      this.handleAriaLabelUpdate();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.handleAriaLabelUpdate();
    });
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    noOptionsText: {
      type: String,
      default: 'Sorry, no matching options.',
    },
  },
  data() {
    return {
      innerValue: null,
    };
  },
  methods: {
    handleSelect(value) {
      this.$emit('onChange', value);
    },
    handleAriaLabelUpdate() {
      const selectElements = document.querySelectorAll('.vs__dropdown-toggle');

      selectElements.forEach((select) => {
        const input = select.firstElementChild.firstElementChild;

        if (input) {
          const {
            textContent: selectValue = '',
            placeholder: defaultValue,
          } = select.firstElementChild.firstElementChild;

          select.ariaLabel = selectValue ? selectValue.trim() : defaultValue;
        }
      });
    },
  },
  watch: {
    innerValue(newValue, oldValue) {
      if (newValue === null && oldValue) {
        this.$emit('onReset');
      }
    },
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss">
.v-select {
  flex-shrink: 0;
  display: inline-block;
  width: 280px;
  height: 40px;
  background-color: #fff;
  border: 1px solid $color-light-border;
  border-radius: 8px;
  cursor: pointer;

  .vs__dropdown-toggle {
    height: 100%;
    padding: 0 10px 0 0px;
  }

  .vs__search {
    padding: 0 0 0 20px;
    margin: 0;
    &::placeholder {
      color: $color-light-text;
      font-size: 18px;
      letter-spacing: 1.29px;
    }
  }
  &.vs--open {
    .vs__selected {
      position: relative;
      opacity: 1;
    }
  }
  .vs__selected {
    padding: 0 0 0 20px;
    margin: 0;
  }

  .vs__actions {
    padding: 0;
    svg {
      fill: $color-light-call-to-action-bg;
    }
  }
  .vs__clear {
    margin-right: 15px;
    margin-top: 3px;
    > svg {
      padding: 3px;
      border: 2px solid $color-white-light-border;
      border-radius: 50%;
      width: 20px;
      height: 20px;
    }
  }
  .vs__dropdown-menu {
    padding: 0;
    max-height: 200px;
  }
  .vs__dropdown-option {
    color: $color-light-call-to-action-bg;
    height: 40px;
    padding: 0 0 0 20px;
    margin: 0;
    line-height: 40px;
    border-bottom: 1px solid $color-light-border;

    &--selected,
    &--highlight {
      background-color: #d8d8d8;
    }
  }
  .vs__no-options {
    height: 40px;
    line-height: 40px;
    padding: 0 0 0 20px;
    text-align: left;
    margin: 0;
  }
  & + .v-select {
    margin-top: 10px;

    @include for-tablet {
      margin-top: 0;
      margin-left: 20px;
    }
  }
}
.selectd {
  background-color: $color-light-btn-bg;
  .vs__selected {
    color: #fff;
  }
  .vs__actions {
    svg {
      fill: #fff;
    }
  }
}
</style>
